/**
 * @module 通知履歴検索条件部共通コンポーネント
 */
import Paginate from 'vuejs-paginate';

export default {
  components: {
    Paginate,
  },
  name: 'NotificationHistorySelector',
  data() {
    return {
      page: 1,
      list: [],
      maxPageSize: 5,
    };
  },
  props: {
    title: {
      type: String,
      default: '',
      require: true,
    },
    checkboxList: {
      type: Array,
      default: () => [],
      require: true,
    },
    isPagination: {
      type: Boolean,
      default: true,
      require: false,
    },
    APP_CU1702: {
      type: Function,
      default: () => {},
    },
    length: {
      type: Number,
      default: 1,
      require: true,
    },
  },
  created() {
    this.pageChange(1);
  },
  watch: {
    checkboxList: {
      handler(newval, oldVal) {
        newval.forEach((e, i) => {
          this.list.forEach((element, index) => {
            if (this.list[index].id == newval[i].id && newval[i] != oldVal[i]) {
              this.list[index] = newval[i];
            }
          });
        });
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    checkApplyDisabled() {
      let disableFlag = true;
      this.checkboxList.forEach((e) => {
        if (e.isChecked) {
          disableFlag = false;
          return;
        }
      });
      return disableFlag;
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 全て選択ボタン押下時のアクション
     */
    selectAll() {
      this.$emit('select-all', this.title);
      this.pcCheck();
    },
    /**
     * クリアボタン押下時のアクション
     */
    clearAll() {
      this.$emit('clear-all', this.title);
      this.pcCheck();
    },
    /**
     * 適用ボタン押下時のアクション
     */
    apply() {
      this.APP_CU1702();
      this.$emit('apply', this.title, this.checkboxList);
    },
    /**
     * キャンセルボタン押下時のアクション
     */
    cancel() {
      this.$emit('cancel', this.title);
    },
    /**
     * ページ切替
     * @param {number} pageNumber 選択したページ
     */
    pageChange(pageNumber) {
      this.list = this.checkboxList.slice(
        this.maxPageSize * (pageNumber - 1),
        this.maxPageSize * pageNumber
      );
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * PCの場合、適用ボタンをスキップして通知情報を再取得する
     */
    pcCheck() {
      if (this.$mq === 'pc' && this.title !== '種別') {
        this.apply();
      }
    },
    /**
     * tabindexを設定
     */
    setPagenationTabIndex() {
      const elements = document.getElementsByClassName('page-number');
      for (let element of elements) {
        element.tabIndex = -1;
      }
    },
  },
  async mounted() {
    this.setPagenationTabIndex();
  },
};
